import { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AppSettingsProvider } from "../../context/AppSettingsContext";
import { getRouteTitle } from "../../lib/route-meta";
import { BottomNav } from "./BottomNav";
import { MobileHeader } from "./MobileHeader";

const MORE_SUB_PAGES = ["/settings", "/disable-dates", "/logs", "/weekly-schedule"];

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const isSubPage = MORE_SUB_PAGES.includes(location.pathname);

  return (
    <AppSettingsProvider>
      <div className="flex min-h-screen justify-center bg-app-shell px-0 py-0">
        <div className="app-phone-frame">
          <MobileHeader
            title={getRouteTitle(location.pathname)}
            showBack={isSubPage}
            onBack={isSubPage ? () => navigate("/menu") : undefined}
          />

          <main className="flex-1 overflow-y-auto bg-surface-sunken/50 px-4 py-4 pb-[84px]">
            <div className="space-y-4">{children}</div>
          </main>

          <BottomNav />
        </div>
      </div>
    </AppSettingsProvider>
  );
}
